'use strict';

const keyCodes = {
    enter: 13,
    space: 32,
    left: 37,
    right: 39,
    up: 38,
    bottom: 40,
};
const isKey = (...keys) => (event) => keys.some(key => event.keyCode === keyCodes[key]);

exports.isKey = isKey;
exports.keyCodes = keyCodes;
//# sourceMappingURL=keyboard.js.map
